import { __rest, __assign } from 'tslib';
import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { NavigationBar } from '@alfalab/core-components-navigation-bar/esm';
import { getDataTestId } from '@alfalab/core-components-shared/esm';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';

var desktopStyles = {"header":"modal__header_glgro","content":"modal__content_glgro","size-500":"modal__size-500_glgro","size-600":"modal__size-600_glgro","size-800":"modal__size-800_glgro","size-1140":"modal__size-1140_glgro","fullscreen":"modal__fullscreen_glgro","sticky":"modal__sticky_glgro"};
require('./desktop.css')

var styles = {"highlighted":"modal__highlighted_1x2s2","sticky":"modal__sticky_1x2s2","hasContent":"modal__hasContent_1x2s2"};
require('./index.css')

var mobileStyles = {"header":"modal__header_1h7m4","sticky":"modal__sticky_1h7m4","content":"modal__content_1h7m4"};
require('./mobile.css')

var Header = function (_a) {
    var _b, _c;
    var className = _a.className, sticky = _a.sticky, title = _a.title, children = _a.children, contentClassName = _a.contentClassName, _d = _a.hasCloser, hasCloser = _d === void 0 ? true : _d, restProps = __rest(_a, ["className", "sticky", "title", "children", "contentClassName", "hasCloser"]);
    var _e = useContext(ModalContext), setHasHeader = _e.setHasHeader, headerHighlighted = _e.headerHighlighted, parentRef = _e.parentRef, onClose = _e.onClose;
    var _f = useContext(ResponsiveContext), view = _f.view, size = _f.size, dataTestId = _f.dataTestId;
    useEffect(function () {
        setHasHeader(true);
    }, [setHasHeader]);
    var hasContent = Boolean(title || children);
    return (React.createElement(NavigationBar, __assign({ dataTestId: getDataTestId(dataTestId, 'header') }, restProps, { scrollableParentRef: parentRef, hasCloser: hasCloser, sticky: sticky, view: view, title: title, onClose: onClose, className: cn(className, (_b = {},
            _b[styles.highlighted] = hasContent && sticky && headerHighlighted,
            _b[styles.sticky] = sticky,
            _b[styles.hasContent] = hasContent,
            _b[desktopStyles.header] = view === 'desktop',
            _b[desktopStyles.sticky] = view === 'desktop' && sticky,
            _b[desktopStyles[SIZE_TO_CLASSNAME_MAP[size]]] = view === 'desktop',
            _b[mobileStyles.header] = view === 'mobile',
            _b[mobileStyles.sticky] = view === 'mobile' && sticky,
            _b)), contentClassName: cn(contentClassName, (_c = {},
            _c[desktopStyles.content] = view === 'desktop',
            _c[mobileStyles.content] = view === 'mobile',
            _c)) }), children));
};

export { Header };
